// Start the animation for BB only when that block comes into view.
const animationHandler = (blockRef: HTMLDivElement) => {
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: [0.5],
  };

  function handleIntersect(entries: IntersectionObserverEntry[]) {
    entries.forEach((entry) => {
      if (!(entry.target instanceof HTMLElement)) {
        return;
      }

      if (entry.intersectionRatio > 0.5) {
        blockRef.dataset.animationState = 'started';
        observer.disconnect();
      }
    });
  }

  const observer = new IntersectionObserver(handleIntersect, options);
  observer.observe(blockRef);

  // Set "unstarted" for the block.
  blockRef.dataset.animationState = 'unstarted';
};

export default animationHandler;
